module.exports = __webpack_public_path__ + "static/media/cq_bozza_messaggio b.b267af0a.svg";